import { Thead, Tr } from '@chakra-ui/react';
import React from 'react';

export const CmTableHeader: React.FC = ({ children }) => {
  return (
    // @ts-ignore TS2590
    <Thead>
      <Tr>{children}</Tr>
    </Thead>
  );
};
